import { render, staticRenderFns } from "./spotons.vue?vue&type=template&id=6ace529d&scoped=true&"
import script from "./spotons.vue?vue&type=script&lang=js&"
export * from "./spotons.vue?vue&type=script&lang=js&"
import style0 from "./spotons.vue?vue&type=style&index=0&id=6ace529d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ace529d",
  null
  
)

export default component.exports